import { useRef, useState } from 'react';

import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';

import { NewSemenForm } from '../new-semen-form';
import { SemenFormValues } from '../new-semen-form/schema';

type NewSemenDialogProps = {
  visible: boolean;
  onHide: () => void;
  initialValues?: Partial<SemenFormValues>;
  onSuccess?: (data: SemenFormValues) => void;
  onError?: (error: unknown) => void;
  'data-testid'?: string;
};

export const NewSemenDialog = ({
  visible,
  onHide,
  initialValues,
  onSuccess,
  onError,
  'data-testid': dataTestId,
}: NewSemenDialogProps) => {
  const { t } = useTranslation();
  const dialogRef = useRef<Dialog>(null);
  const [dialogContainer, setDialogContainer] = useState<HTMLElement>();

  return (
    <Dialog
      ref={dialogRef}
      header={t('semen.newSemen')}
      visible={visible}
      onHide={onHide}
      modal
      className="w-[1000px] max-w-[95vw]"
      data-testid={dataTestId}
      onShow={() =>
        setDialogContainer(dialogRef.current?.getMask() ?? undefined)
      }
    >
      <NewSemenForm
        initialValues={initialValues}
        onCancel={onHide}
        onSuccess={onSuccess}
        onError={onError}
        calendarContainer={dialogContainer}
      />
    </Dialog>
  );
};
